import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { pageSchemas } from "@/lib/seo/page-schema";
import { MediaMonitoringOverviewPage } from "@/components/site/MediaMonitoringOverviewPage";
import { MEDIA_MONITORING_META_DESCRIPTION } from "@/content/meta/MediaMonitoringOverviewPage";

export const Route = createFileRoute("/media-monitoring/")({
  head: () => ({
    meta: [
      { title: "Media Monitoring Services in Southeast Europe | Perceptica" },
      { name: "description", content: MEDIA_MONITORING_META_DESCRIPTION },
      { property: "og:title", content: "Media Monitoring Services in Southeast Europe | Perceptica" },
      { property: "og:description", content: MEDIA_MONITORING_META_DESCRIPTION },

      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Media Monitoring Services in Southeast Europe | Perceptica" },
      { name: "twitter:description", content: MEDIA_MONITORING_META_DESCRIPTION },
      { property: "og:url", content: "https://perceptica.com/media-monitoring" },
      ...ogImageMeta("en", "/media-monitoring"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "en", path: "/media-monitoring/index", service: { name: "Media monitoring", description: "Perceptica media monitoring for Southeast Europe.", serviceType: "Media monitoring" } }),
  }),
  component: MediaMonitoringOverviewPage,
});
